export default __webpack_public_path__ + "static/media/28.d58750e5.png";